<div class="body">
  <!-- <div class="main-top-text">
    演讲征集现已开启!
 
    <a style="text-align: right;float: right;margin-right: 20px;display: inline-block;color: #fff;" href="https://ivorysql.io/" target="_blank">
      <img src="./../../assets/images/en.png" alt="" style="margin-right: 10px;" width="20px" height="20px">
      <span>EN</span>
    </a>
    <div class="join-class">
    <span  (click)="isVisibleMiddle=true" style="" class="open-join">
      参会报名
    </span>
    </div>

  </div> -->
  <div class="main-top-img">
    <picture>
      <!-- 小于768px时显示此图 -->
      <source media="(max-width: 768px)"HOW生态大会倒计时
              srcset="../../../assets/images/shouye/mobile-header.png">
      <!-- 默认显示此图 -->
      <img src="../../../assets/images/shouye/header.jpg" 
           class="banner-img-main"
           alt="Banner Image">
    </picture>
  <!-- <img src="../../../assets/images/shouye/header.jpg" class="banner-img-main"> -->
    <!-- <button  class="b-btn-orange submit-btn main-top-sign" (click)="isVisibleMiddle=true" style="align-self: end">参会报名<i class="iconfont icon-jiantou_xiangyou" style="font-size: 18px;margin: 10px;"></i></button> -->
    <!-- <img src="../../../assets/images/title-conference.jpg" class="banner-img"> -->
  </div>
  <div style="margin: 0 auto;max-width: 1344px;margin-top: 60px;">
    <div style="padding: 0 2%;text-align: center;">
      <div class="item">
        <div class="item-title" style="padding-left: 20px;">
          <span>大会概览</span>
          <span class="test"> / ABOUT</span>
        </div>
        <div class="about-content">
            <div class="content">
              <div>
                IvorySQL 2025生态大会将于 6月 27日在济南开幕，汇集来自开源和PostgreSQL社区的采用者和国内外技术专家。本次大会将以PostgreSQL技术生态为核心，聚焦全球数据库技术发展趋势、开源创新与行业实践，打造产学研用深度融合的技术交流平台。大会为期两天，围绕PostgreSQL进行协作、学习和创新，共同推动PostgreSQL技术的未来。
            </div>
            </div>
            <div class="content">
              <div>
                一场以 “开源技术创新” 为核心，聚焦数据库技术、生态协作与产业赋能的全球性高端峰会。汇聚开发者智慧、行业前瞻洞察与政策方向解读，推动数据库技术革新与数字化未来，让世界看见中国开源的力量！
              </div>
            </div>
        </div>
        <div class="about-circle">
          <div class="circle-item cir1">
            <div class="num">2000+</div>
            <div class="circle-item-text">参会者</div>
          </div>
          <div class="circle-item cir2">
            <div class="num">50+</div>
            <div class="circle-item-text">技术大咖</div>
          </div>
          <div class="circle-item cir1">
            <div class="num">15<span style="font-size: 1.2rem;">个</span></div>
            <div class="circle-item-text">精彩论坛</div>
          </div>
          <div class="circle-item cir2">
            <div class="num">2<span style="font-size: 1.2rem;">天</span></div>
            <div class="circle-item-text">实时直播</div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          <span>大会亮点</span>
          <span class="test"> / HIGHLIGHTS</span>
        </div>
        <div class="brightened">
          <div class="brightened-content">
            <div class="brightened-content-item">
              <img src="../../../assets/images/shouye/icon1.svg" alt="" width="100px" height="100px">
            </div>
            <div style="align-self: baseline;">
              <div class="brightened-content-text1">PG技术纵览</div>
              <div class="brightened-content-text2">覆盖数据库前沿趋势、内核技术、云原生、运维管理等全栈领域，汇聚全球PG技术领袖与开发者。</div>
            </div>
          </div>
          <div class="brightened-content" style="margin-right: 5%;">
            <div class="brightened-content-item">
              <img src="../../../assets/images/shouye/icon2.svg" alt="" width="100px" height="100px">
            </div>
            <div style="align-self: baseline;">
              <div class="brightened-content-text1">IvorySQL生态主场</div>
              <div class="brightened-content-text2">通过生态共建发布及实践案例，展现中国开源力量在全球PG生态中的创新影响力。</div>
            </div>
          </div>
          <div class="brightened-content">
            <div class="brightened-content-item">
              <img src="../../../assets/images/shouye/icon3.svg" alt="" width="100px" height="100px">
            </div>
            <div style="align-self: baseline;">
              <div class="brightened-content-text1">多维场景融合</div>
              <div class="brightened-content-text2">从行业应用到职业发展，构建开发者、企业、学术机构、开源社区联动的技术生态圈。</div>
            </div>
          </div>
          <div class="brightened-content" style="margin-right: 5%;">
            <div class="brightened-content-item">
              <img src="../../../assets/images/shouye/icon4.svg" alt="" width="100px" height="100px">
            </div>
            <div style="align-self: baseline;">
              <div class="brightened-content-text1">开源协作新范式</div>
              <div class="brightened-content-text2">设立国际化议题与跨区域开发者对话，通过线上线下联动，推动全球PG社区协作与知识共享，深化中国开源力量与国际生态的融合。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="item" style="margin-bottom: -40px;">
        <div class="item-title">
          <span>大会价值</span>
          <span class="test"> / VALUE</span>
        </div>
        <div class="brightened">
          <div class="brightened-content-column">
            <div class="brightened-content-item">
              <img src="../../../assets/new/value4.png" alt="" width="100px;" height="100px">
            </div>
            <div>
              <div class="brightened-content-text1" style="text-align: center;">技术风向标</div>
              <div class="brightened-content-text2">全球PG技术领袖与KOL分享前瞻洞见，指引生态发展方向。</div>
            </div>
          </div>
          <div class="brightened-content-column">
            <div class="brightened-content-item">
              <img src="../../../assets/new/value3.png" alt="" width="100px;" height="100px">
            </div>
            <div>
              <div class="brightened-content-text1" style="text-align: center;">行业助推器</div>
              <div class="brightened-content-text2">通过真实场景案例，加速PG技术在关键行业的规模化落地。</div>
             
            </div>
          </div>
          <div class="brightened-content-column">
            <div class="brightened-content-item">
              <img src="../../../assets/new/value2.png" alt="" width="100px;" height="100px">
            </div>
            <div>
              <div class="brightened-content-text1" style="text-align: center;">生态连接器</div>
              <div class="brightened-content-text2">链接开发者、企业、高校与开源社区，推动PG 和IvorySQL生态资源整合。</div>
            </div>
          </div>
          <div class="brightened-content-column" >
            <div class="brightened-content-item">
              <img src="../../../assets/new/value1.png" alt="" width="100px" height="100px">
            </div>
            <div>
              <div class="brightened-content-text1" style="text-align: center;">社区成长引擎</div>
              <div class="brightened-content-text2">通过开源贡献引导与社区激励机制，构建PG与IvorySQL可持续的开发者生态，助力开源社区长期繁荣。</div>
            </div>
          </div>
        </div>
      </div>
        <div class="item" style="margin-top: 60px;">
        <div class="item-title">
          <span>国外嘉宾</span>
          <span class="test"> / FOREIGN GUESTS</span>
        </div>
        <div class="guest">
          <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/jiabin-1.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">Bruce Momjian</div>
              <div class="line-color-div">
                <div class="line-color-one" style="width: 65%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">EDB 副总裁<br/>PostgreSQL 核心团队成员</div>
            </div>
          </div>
           <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/jiabin-2.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">Abhilekh Verma</div>
              <div class="line-color-div">
                <div class="line-color-one" style="width: 68%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">Abhilekh Verma 咨询公司（OPC）私人有限公司 董事
</div>
            </div>
          </div>
           <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/jiabin-3.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">Cédric Villemain</div>
              <div class="line-color-div">
                        <div class="line-color-one" style="width: 70%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">Data Bene公司创始人兼CEO，原法国第二象限公司创始人</div>
            </div>
          </div>
             <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/jiabin-4.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">Florents Tselai</div>
              <div class="line-color-div">
                       <div class="line-color-one" style="width: 60%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">数据战略及工程专家</div>
            </div>
          </div>
           <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/jiabin-5.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">Nilanjan Chatterjee</div>
              <div class="line-color-div">
                       <div class="line-color-one" ></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">Sr. Staff Data Architect<br/> AMD高级数据架构师</div>
            </div>
          </div>
                   <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/jiabin-6.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">Chris Travers</div>
              <div class="line-color-div">
                       <div class="line-color-one" style="width: 55%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">业务流程管理分析师<br/> (沃尔顿希腊能源)</div>
            </div>
          </div>
          
        </div>
        <div style="color: #999999;margin-top: 20px;cursor: pointer;" routerLink="/guest">
          查看全部国外嘉宾
          <img src="../../../assets/images/shouye/guest/Dropdown.png" alt="">
            <img src="../../../assets/images/shouye/guest/Dropdown.png" alt="">
              <img src="../../../assets/images/shouye/guest/Dropdown.png" alt="">
        </div>
      </div>

       <div class="item" style="margin-top: 60px;">
        <div class="item-title">
          <span>国内嘉宾</span>
          <span class="test"> / DOMESTIC GUESTS</span>
        </div>
        <div class="guest">
          <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/cn/jiabin1.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">白鳝</div>
              <div class="line-color-div">
                <div class="line-color-one" style="width: 20%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">PostgreSQL ACE Director<br/>基石数据CTO</div>
            </div>
          </div>
           <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/cn/jiabin2.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">崔鹏</div>
              <div class="line-color-div">
                <div class="line-color-one" style="width: 20%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">计算机学博士<br/>PostgreSQL ACE</div>
            </div>
          </div>
           <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/cn/jiabin3.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">德哥</div>
              <div class="line-color-div">
                        <div class="line-color-one" style="width: 20%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">PostgreSQL ACE Director</div>
            </div>
          </div>
             <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/cn/jiabin4.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">吕海波</div>
              <div class="line-color-div">
                       <div class="line-color-one" style="width: 30%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">PostgreSQL ACE Director<br/>
北京大学软微学院企业导师</div>
            </div>
          </div>
           <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/cn/jiabin5.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">冯若航</div>
              <div class="line-color-div">
                       <div class="line-color-one" style="width: 30%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">独立开源贡献者<br/> Pigsty作者</div>
            </div>
          </div>
                   <div class="guest-content">
            <div class="guest-content-item">
              <img src="../../../assets/images/shouye/guest/cn/jiabin6.png" alt="">
            </div>
            <div>
              <div class="guest-content-text1">罗敏</div>
              <div class="line-color-div">
                       <div class="line-color-one" style="width: 20%;"></div>
                <div class="line-color-two"></div>
              </div>
              <div class="guest-content-text2">资深数据库技术顾问</div>
            </div>
          </div>
        </div>
        <div style="color: #999999;margin-top: 20px;cursor: pointer;" routerLink="/guest">
          查看全部国内嘉宾
          <img src="../../../assets/images/shouye/guest/Dropdown.png" alt="">
            <img src="../../../assets/images/shouye/guest/Dropdown.png" alt="">
              <img src="../../../assets/images/shouye/guest/Dropdown.png" alt="">
        </div>
      </div>

         <div class="item speech-item" style="margin-bottom: -150px;margin-top: -120px;">
        <div class="item-title">
          <span>大会议程</span>
          <span class="test"> / AGENDA</span>
        </div>
        <div class="agenda-model-content"> 
          <div class="agenda-model-content-item">
            <div class="agenda-line"></div>
            <div class="agenda-date">Friday周五</div>
            <div style="font-weight: bold;font-size: 25px;margin-top: 10px;">6月27日</div>
            <button class="agenda-main-btn">上午活动日程/主论坛</button>
            <div>
                <div class="agenda-date">9:00AM-11:40AM</div>
                <div style="font-weight: bold;">开场致辞</div>
                <div style="font-weight: 400;color: #444;font-size: 14px;">主讲人：张熙、程晓明</div>
                <div style="font-weight: bold;margin-top: 20px;">开放源码运动与中国开源教育</div>
                <div style="font-weight: 400;color: #444;font-size: 14px;">主讲人：周傲英</div>
                <div style="font-weight: bold;margin-top: 20px;">从代码到商业：当代开源项目商业模式</div>
                <div style="font-weight: 400;color: #444;font-size: 14px;">主讲人：Micheal Meskes</div>
                <div style="font-weight: bold;margin-top: 20px;">数据库技术前沿演进与实践：分布式并行数据库技术与系统</div>
                <div style="font-weight: 400;color: #444;font-size: 14px;">主讲人：丁治明</div>
                <div style="font-weight: bold;margin-top: 20px;">Postgres的发展历程</div>
                <div style="font-weight: 400;color: #444;font-size: 14px;">主讲人：Bruce Momjian</div>
                <div style="font-weight: bold;margin-top: 20px;">开源数据库的中国力量</div>
                <div style="font-weight: 400;color: #444;font-size: 14px;">主讲人：吕新杰</div>
                 <div style="font-weight: bold;margin-top: 20px;">开放原子开源基金IvorySQL贡献协议签约仪式</div>
            </div>
            <button class="agenda-main-btn" >下午活动日程/分论坛</button>
            <div>
                        
                <div class="agenda-date">14:00PM-17:00PM</div>
                <!-- <div style="font-weight: bold;margin-bottom: 20px;">数据库生态</div>
                <div style="font-weight: bold;">国际论坛（英文）：</div>
                <div style="font-size: 14px;margin-bottom: 20px;">
                  《PostgreSQL的发展历程》<br/>
《PostgreSQL数据工程战略：从古代战略思想到Postgres拓展》<br/>
《转向开源：为什么PostgreSQL和IvorySQL在商业上有意义》<br/>
《PostgreSQL 18与异步I/O：面向现代数据工作负载的架构性飞跃》
                </div> -->
                <div style="font-weight: bold;">国际论坛(PG 英文)专场</div>
                <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人：周宝峰，Bruce Momjian
                </div>
                <div style="font-weight: bold;">GIS 专场</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                 出品人:陈丽娜
                </div>
                <div style="font-weight: bold;">智能运维新纪元:构建高可用、高稳定性的PostgreSQL服务</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                 出品人:白鳝、熊灿灿
                </div>
                <div style="font-weight: bold;">引擎之心:PostgreSQL及衍生内核深度探索与前瞻</div>
                     <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:吕海波，杨向博
                </div>
                <div style="font-weight: bold;">云巅论道:PostgreSQL 的云原生演进与架构革新</div>
                       <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:唐成、刘华阳
                </div>
                 <div style="font-weight: bold;">医疗分论坛</div>
                       <div style="font-size: 14px;;margin-bottom: 20px;">
                  出品人:高通
                </div>
                <div style="font-weight: bold;">战略圆桌：驾驭AI浪潮，数据库人的核心竞争力升维之路</div>
                       <div style="font-size: 14px;">
                  出品人：肖少聪、白国华
                </div>
            </div>
            <div>
            </div>
            <button routerLink="/agenda" class="b-btn-0242fc submit-btn" style="align-self: center;padding: 10px 50px;margin-top: 35px;" >了解详情</button>
          </div>
           <div class="agenda-model-content-item">
            <div class="agenda-line-two"></div>
            <div class="agenda-date">Saturday周六</div>
            <div style="font-weight: bold;font-size: 25px;margin-top: 10px;">6月28日</div>
            <button class="agenda-main-btn">上午活动日程/分论坛</button>
            <div>
                <div class="agenda-date">9:00AM-11:30AM</div>
                <!-- <div style="height: 26px;">敬请期待...</div> -->
                 <div style="font-weight: bold;">国际论坛(PG 英文专场)</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:周宝峰
                </div>
                <div style="font-weight: bold;">行业深耕:PostgreSQL 根技术在关键领域的规模化落地</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:林春，于巍
                </div>
                 <div style="font-weight: bold;">象心力助梦:数据库技术人才的成长阶梯与职业蓝图</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:梁敬彬、尹海文
                </div>
                <div style="font-weight: bold;">利器智造:PostgreSQL 扩展开发与智能工具链革新</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:冯若航、张达刚
                </div>
                <div style="font-weight: bold;">优化之巅:PostgreSQL 全方位调优与智能化诊断</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:罗敏，王丁丁
                </div>
            </div>
            <button class="agenda-main-btn" >下午活动日程/分论坛</button>
            <div>
                        
                <div class="agenda-date">14:00PM-17:00PM</div>
              <div style="font-weight: bold;">线上国际论坛(PG 英文专场)</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:周宝峰
                </div>
                   <div style="font-weight: bold;">智汇数据:PostgreSQL的 AI融合创新与应用前沿</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:德哥、崔鹏
                </div>
                    <div style="font-weight: bold;">新版释能:PostgreSQL 及国产数据库特性深度解读与实战精华</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:彭冲、严少安
                </div>
                 <div style="font-weight: bold;">实战工坊:PostgreSQL从零基础到进阶实战技能特训</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:阎书利
                </div>
                <div style="font-weight: bold;margin-bottom: 20px;">创投活动(泰山开源技术孵化器)</div>
                 
                  <div style="font-weight: bold;">源力聚桥:开源协作的全球化实践与人才破壁</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:敬请期待
                </div>
                 <div style="font-weight: bold;margin-bottom: 20px;">战略圆桌:驾驭AI浪潮，数据库人的核心竞争力升维之路</div>
      
                 <div style="font-weight: bold;">战略圆桌:谁会领导下一个20年?信创浪潮下，数据库产业转型与核心竞争力重构</div>
                  <div style="font-size: 14px;margin-bottom: 20px;">
                  出品人:萧少聪、白国华
                </div>
            </div>
            <button routerLink="/agenda"  class="b-btn-0242fc submit-btn" style="align-self: center;padding: 10px 50px;margin-top: 60px;">了解详情</button>
          </div>
        </div>
      </div>
      <div class="item speech-item" style="margin-bottom: -60px;margin-top: -6px;">
        <div class="item-title">
          <span>演讲征集</span>
          <span class="test"> / SPEECH COLLECTION</span>
        </div>
        <div class="speech-content"> 
          <div class="speech-content-item">
            <div>
              <p>IvorySQL 2025生态大会设置了主论坛和分论坛，主论坛内容聚焦在 PostgreSQL的发展趋势与 IvorySQL的创新之路及生态实践，分论坛围绕 PostgreSQL技术展开，共设置七个方向，分别为：数据库生态、运维与管理、核心技术、云原生、国际论坛、行业应用、职业发展。现在，大会面向 PostgreSQL领域的各位技术大拿和爱好者们公开征集分论坛的议题，为每个议题提供不多于 40分钟的分享时间。</p>
              <p>您可以提交以下主题方向的议题信息: <br/>
                PG内核技术、PG开发、PG运维与管理、PG与云原生、PG行业应用、PG开源贡献、IvorySQL 实践应用、IvorySQL开发、IvorySQL 运维与管理、IvorySQL 生态合作。
              </p>
            </div>
            <button  class="b-btn-0242fc submit-btn" (click)="goUrlBySend('https://jsj.top/f/Tr5eXn')" style="align-self: end">提交演讲<i class="iconfont icon-jiantou_xiangyou" style="font-size: 18px;margin: 10px;"></i></button>
            <!-- <button *ngIf="isThemeEnd" class="g-btn submit-btn" disabled style="width: 200px;align-self: end">演讲提交已截止</button> -->
          </div>
          <div class="speech-content-item">
            <div>
              <p>组委会将在6月16日前完成演讲评审，并通知审核通过的嘉宾。若您的演讲通过评审，请下载并使用大会统一的PPT模板（后续将上传PPT模板，敬请关注）。 </p>
              <!-- <p>PPT提交截止到1月31日，剩余{{timeDay1}}天。</p><br/> -->
            </div>
            <!-- *ngIf="!isEnd" -->
            <a style="align-self: end" href="../../../assets/modal2025.pptx" download="2025生态大会PPT模版.pptx">
              <button  class="b-btn-blue submit-btn">下载PPT模板<i class="iconfont icon-xiazai" style="font-size: 18px;margin: 10px;"></i></button>
            </a>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="item-title">
          <span>合作</span>
          <span class="test"> / COOPERATE</span>
        </div>
        <div style="text-align: left;">
          <div class="organize">主办单位</div>
          <div class="org-img">
            <img src="../../../assets/images/shouye/comp1.jpg" >
          </div>
          <div style="display: flex;">
            <div  style="display: flex;flex-wrap: wrap;width: 630px;">
                <div class="organize">支持单位</div>
                <div class="org-img">
                  <img src="../../../assets/images/shouye/comp2.jpg">
                  <img src="../../../assets/images/shouye/comp3.jpg">
                  <img src="../../../assets/images/shouye/comp4.jpg">
                </div>
            </div>
            <div style="width: 250px;">
                <div class="organize">承办单位</div>
                <div class="org-img">
                  <img src="../../../assets/images/shouye/comp5.jpg">
                </div>
            </div>
          </div>
          <div class="organize">合作社区</div>
          <div class="org-img" style="margin-bottom: 30px;">
           <img src="../../../assets/images/shouye/comp6.jpg">
           <img src="../../../assets/images/shouye/comp7.jpg">
           <img src="../../../assets/images/shouye/comp8.jpg">
           <img src="../../../assets/images/shouye/comp9.jpg">
           <img src="../../../assets/images/shouye/comp14.jpg">
          </div>
          <div class="org-img" style="margin-bottom: 30px;">
            <img src="../../../assets/images/shouye/comp10.jpg">
            <img src="../../../assets/images/shouye/comp11.jpg">
            <img src="../../../assets/images/shouye/comp12.jpg">
            <img src="../../../assets/images/shouye/comp13.jpg">
            <img src="../../../assets/images/shouye/comp15.jpg">
          </div>
        </div>
      </div>

      <div class="item">
        <div class="item-title">
          <span>会议地点</span>
          <span class="test"> / LOCATION</span>
          <div class="location-class">
            <picture>
              <!-- 小于768px时显示此图 -->
              <source media="(max-width: 768px)" 
                      srcset="../../../assets/images/shouye/ditu.png">
              <!-- 默认显示此图 -->
              <img src="../../../assets/images/shouye/didian.jpg" 
                   class="banner-img-main"
                   alt="Banner Image"
                   >
            </picture>
           
          </div>
        </div>
              
      </div>
    </div>
  </div>
</div>

<nz-modal
[(nzVisible)]="isVisibleMiddle"
nzCentered
(nzOnCancel)="handleCancelMiddle()"
(nzOnOk)="handleOkMiddle()"
[nzTitle]="modalTitle"
[nzContent]="modalContent"
[nzFooter]="modalFooter"
[nzWidth]="300"
>
<ng-template #modalTitle id="sign-modal">

</ng-template>
      <ng-template #modalContent>
        <div style="text-align: center;">
            <img src="../../../assets/images/shouye/guest/baoming.png" alt="" style="margin-top: 20px;width: 200px;height: 200px;">
        </div>
   
      </ng-template>

      <ng-template #modalFooter></ng-template>
</nz-modal>